import type { ArrivalNoticeDeliveryDestionation } from '@models/next/ArrivalNotice';
import { DeliveryDestinationOptionsType } from '@models/next/DeliveryDestinationOptionsType';
import type { DeliveryRequestPickupAddress } from '@models/next/DeliveryRequestPickupAddress';
import { createStrings } from '@utils/local';

export const arrivalNoticeStrings = createStrings({
  ja: {
    arrivalNotice: 'Arrival Notice',
    house_bl_number: 'HBL',
    shipper: 'Shipper',
    consignee: 'Consignee',
    shipping_mark: 'Shipping Mark',
    vessel: 'Vessel',
    vessel_schedule: 'Vessel',
    voyage: 'Voyage',
    pod: 'POD',
    pol: 'POL',
    etd: 'ETD',
    eta: 'ETA',
    commodity: 'Commodity',
    nos: 'Quantity',
    packages: 'Packages',
    gross_weight: 'Gross Weight',
    measurement: 'Measurement',
    d2d_taxable_amount: 'D2D課税金額',
    overseaLocalAmount: '海外ローカル費用',
    delivery_destination: '搬入先',
    delivery_destination_code: '搬入先CODE',
    sea_delivery_destination: '海上搬入先',
    sea_delivery_destination_code: '海上搬入先CODE',
    payment_info: '海上A/N支払明細',
    repository: '倉庫名',
    address: '住所',
    tel: 'Tel',
    fax: 'Fax',
    principal_name: '担当',
    invoiceItem: '請求項目',
    numberUnit: '数量・単位',
    singlePrice: '単価',
    untaxedAmount: '税抜金額',
    jobNo: 'JOB NO',
    errorInconsistentDeliveryDestination:
      '注意：17番D2D搬入先と18番海上搬入先が一致していません。確認してください。',
    errorAlreadyLocked: '既にロックされました。',
    errorSeaDeliveryDestinationNotFound:
      '基幹システムからの海上搬入先が見つかりません。ITにご連絡ください。',
    errorNotOtherDeliveryDestination:
      '海上搬入先が空欄の場合は、集荷先が「その他」でのみロックできます。',
    warningUnlock: 'Admin権限を利用してArrival Noticeロックを解除しますか？',
    warningNoPaymentInfo: 'A/N支払明細が見つかりません。',
    warningNoPaymentDetails: '基幹システムからの支払情報がありますが、支払明細の項目がありません。',
  },
});

export type DeliveryDestinationOptions = Omit<ArrivalNoticeDeliveryDestionation, 'repository'> & {
  port_of_discharge: string;
  type: DeliveryDestinationOptionsType;
  d2d_system_name: string;
};

export const deliveryDestinationOptions: DeliveryDestinationOptions[] = [
  {
    delivery_destination: '中外海運倉庫㈱大阪ﾛｼﾞｽﾃｨｯｸｾﾝﾀｰ',
    delivery_destination_code: '4IDA1',
    port_of_discharge: '大阪',
    type: 'FC A/N自社倉庫',
    address: '大阪市住之江区南港南7-1-6 丸新港運㈱内',
    tel: '06-6613-1181',
    fax: '06-6613-1183',
    principal_name: '中西',
    d2d_system_name: 'FC OSAKA',
  },
  {
    delivery_destination: '三井倉庫港運㈱大阪港総合流通センター',
    delivery_destination_code: '4IWA3',
    port_of_discharge: '大阪',
    type: 'FC A/N契約倉庫',
    address: '大阪市住之江区南港中7-4-110',
    tel: '06-6612-3461',
    fax: '06-6614-7233',
    principal_name: '栂尾',
    d2d_system_name: 'MITSUI OSAKA',
  },
  {
    delivery_destination: '関西ｶｰｺﾞﾄﾗﾝｽ株式会社',
    delivery_destination_code: '4IWT7',
    port_of_discharge: '大阪',
    type: 'FC A/N契約倉庫',
    address: '大阪市住之江区南港南1-1-125',
    tel: '06-6105-1705',
    fax: '06-6105-1706',
    principal_name: 'ご担当者',
    d2d_system_name: 'KCT',
  },
  {
    delivery_destination: '中外海運倉庫㈱東京物流ｾﾝﾀｰ保税蔵置場',
    delivery_destination_code: '1FWV8',
    port_of_discharge: '東京',
    type: 'FC A/N自社倉庫',
    address: '大田区東海1-3-6 ﾌﾟﾛﾛｼﾞｽﾊﾟｰｸ2F',
    tel: '03-6303-6616',
    fax: '03-6303-6615',
    principal_name: '馬場',
    d2d_system_name: 'FC TOKYO',
  },
  {
    delivery_destination: '㈱ブルーウィング 品川センター保税蔵置場',
    delivery_destination_code: '1FWS5',
    port_of_discharge: '東京',
    type: 'FC A/N契約倉庫',
    address: '品川区八潮3-2-34',
    tel: '03-3799-5111',
    fax: '03-3799-5112',
    principal_name: '佐藤',
    d2d_system_name: 'BLUE WING TOKYO',
  },
  {
    delivery_destination: '共栄商事株式会社平和島',
    delivery_destination_code: '1GW91',
    port_of_discharge: '東京',
    type: 'FC A/N契約倉庫',
    address: '大田区平和島3-5-1',
    tel: '03-3765-3301',
    fax: '03-3765-8671',
    principal_name: 'ご担当者',
    d2d_system_name: 'KYOEI',
  },
  {
    delivery_destination: 'JHSS株式会社プロロジスパーク東京 大田7F',
    delivery_destination_code: '1FWX6',
    port_of_discharge: '東京',
    type: 'FC A/N契約倉庫',
    address: '大田区東海1丁目3-6',
    tel: '03-6303-6845',
    fax: '03-6303-6996',
    principal_name: 'ご担当者',
    d2d_system_name: 'JHSSTK',
  },
  {
    delivery_destination: '中外海運倉庫株式会社摩耶埠頭倉庫',
    delivery_destination_code: '3DW09',
    port_of_discharge: '神戸',
    type: 'FC A/N自社倉庫',
    address: '神戸市灘区摩耶埠頭１－１',
    tel: '078-871-5588',
    fax: '078-871-6014',
    principal_name: 'ご担当者',
    d2d_system_name: 'FC KOBE MAYA',
  },
  {
    delivery_destination: '東海協和株式会社流通センター（NTC）',
    delivery_destination_code: '5EWA2',
    port_of_discharge: '名古屋',
    type: 'FC A/N他社倉庫',
    address: '名古屋市港区入船一丁目1番20号',
    tel: '0567-55-0221',
    fax: '0567-55-2097',
    principal_name: '小嶋',
    d2d_system_name: 'TOKAI NAGOYA',
  },
  {
    delivery_destination: '鶴丸海運株式会社',
    delivery_destination_code: '6TWH0',
    port_of_discharge: '博多',
    type: 'FC A/N他社倉庫',
    address: '福岡市東区原田4-32-40',
    tel: '092-629-2316',
    fax: '092-622-0749',
    principal_name: '半田',
    d2d_system_name: 'TSURU HAKATA',
  },
  {
    delivery_destination: 'その他',
    delivery_destination_code: 'RANDOM',
    port_of_discharge: 'その他',
    type: '他社A/N他社倉庫',
    address: '',
    tel: '',
    fax: '',
    principal_name: '',
    d2d_system_name: '',
  },
];

export const resolveDeliveryDestinationOptions = (
  data: DeliveryRequestPickupAddress,
): DeliveryDestinationOptions & Pick<DeliveryRequestPickupAddress, 'repository'> => {
  const { delivery_destination, delivery_destination_code } = data;

  const info = deliveryDestinationOptions.find(
    (d) => d.delivery_destination_code === delivery_destination_code,
  );

  if (info) {
    if (delivery_destination !== 'その他') {
      return {
        ...info,
        repository: info.delivery_destination,
      };
    } else {
      return {
        ...info,
        ...data,
      };
    }
  } else {
    throw new Error('Delivery destination is not found');
  }
};
